import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import axios from "axios";
import { Button, Toast } from "../../components";
import { Input } from "../../components";
import { PasswordIcon, PasswordIconSolid, UserIcon, UserIconSolid } from "../../components/Icons/Icons";
import Logo from "../../assets/images/logo-1.png";
import styles from "./Login.module.css";
import CompanyIcon from "../../components/Icons/Login/Company";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);
const Login = () => {
  const navigate = useNavigate()
  const [userName, setUserName] = useState();
  const [taxCode, setTaxCode] = useState();
  const [password, setPassword] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [count, setCount] = useState(0);
  const { t } = useTranslation();

  const handleChangeUserName = (data) => {
    setUserName(data.toLowerCase());
  };
  const handleChangeTaxCode = (data) => {
    setTaxCode(data.toUpperCase());
  };
  const handleChangePassword = (data) => {
    setPassword(data);
  };
  const handleSubmitForm = async (e) => {
    e.preventDefault()
    if (userName?.trim()?.length > 0 && password?.trim()?.length > 0 && taxCode?.trim()?.length > 0) {
      sessionStorage.clear();
      localStorage.clear();
      try {
        setIsSubmit(false)
        if (true) {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}authenticator/login/`,
            {
              username: userName,
              password: password,
              tax_code: taxCode,
              license: '2a7af975010c4e7eb2ff70d657ad8eab'
            }
          );
          sessionStorage.setItem("token", res.data.access)
          sessionStorage.setItem("refresh", res.data.refresh)
          sessionStorage.setItem("role", res.data.role)
          localStorage.setItem("token", res.data.access)
          localStorage.setItem("refresh", res.data.refresh)
          localStorage.setItem('role', res.data.role)
          setCount(0)
          if (res?.data?.status === "0") {
            // window.location.reload()
            const token = res.data.access;
            navigate("/change-new-password", { state: { token: token } })
          } else {
            navigate("/");
            window.location.reload()
          }
        }
      } catch (e) {
        setCount(count + 1)
        setIsSubmit(true)
        if (e.response.data.detail) {
          Toast.open(e.response.data.detail, "danger")
        }
      }
    }
  };
  return (
    <div className={cx("container")}>
      <div id="__notification"></div>
      <div className={cx('fill-background')}></div>
      <div className={cx("content")}>
        <div className={cx("logo")}>
          <img src={Logo} alt="Logo" style={{ width: '48px', height: '48px' }} />
        </div>
        <div className={cx("title")}>
          <h1>{t("login.login")}</h1>
          <p className={cx("description")}>{t("login.typeInfo")}</p>
        </div>
        <form onSubmit={handleSubmitForm}>
          <Input
            placeholder={t("login.companyCode")}
            onChange={handleChangeTaxCode}
            value={taxCode}
            rules={[
              {
                required: true,
                mess: t("login.companyCodeEmptyError"),
              },
              {
                companyCode: true,
                mess: t("login.companyCodeType"),
              },
            ]}
            icon={<CompanyIcon />}
            isSubmit={isSubmit}
            setIsSubmit={setIsSubmit}
          />
          <Input
            placeholder={t("login.userName")}
            onChange={handleChangeUserName}
            value={userName}
            rules={[
              {
                required: true,
                mess: t("login.userNameEmptyError"),
              },
              {
                min: 6,
                mess: t("login.userNameType"),
              },
              {
                max: 150,
                mess: t("login.userNameType"),
              },
              {
                userName: true,
                mess: t("login.userNameType"),
              },
            ]}
            icon={<UserIconSolid />}
            isSubmit={isSubmit}
            setIsSubmit={setIsSubmit}
          />
          <Input
            placeholder={t("login.typePass")}
            type="password"
            onChange={handleChangePassword}
            value={password}
            rules={[
              {
                required: true,
                mess: t("login.passEmptyError"),
              },
              {
                min: 6,
                mess: t("login.passType"),
              },
              {
                max: 20,
                mess: t("login.passType"),
              },
              {
                password: true,
                mess: t("login.passType"),
              },
            ]}
            icon={<PasswordIconSolid />}
            isSubmit={isSubmit}
            setIsSubmit={setIsSubmit}
          />
          <button className={cx('button-login')}>
            <Button
              onClick={e => (e)}
              className={cx("btn")}
              title={t("login.login")}
            />
          </button>
        </form>
        <Link style={{ textDecoration: "none" }} to={'/forgot-password'}>
          <p className={cx("forgot")}>{t("login.forgottenPass")}</p>
        </Link>
      </div>

    </div>
  );
};

export default Login;
